import { create } from 'zustand';

export type FlagsClientState = {
  debug: boolean;
  demoMode: boolean;
  surfopsMode: boolean;
};

const initialFlagsState = (): FlagsClientState => ({
  debug: false,
  demoMode: false,
  surfopsMode: false,
});

export const useFlagsStore = create<FlagsClientState>(() =>
  initialFlagsState()
);

export function resetFlagsStore(): void {
  useFlagsStore.setState(initialFlagsState());
}

export function setDebugFlag(enabled: boolean): void {
  useFlagsStore.setState({ debug: enabled });
}

export function setDemoModeFlag(enabled: boolean): void {
  useFlagsStore.setState({ demoMode: enabled });
}

export function setSurfopsModeFlag(enabled: boolean): void {
  useFlagsStore.setState({ surfopsMode: enabled });
}
